import TabelaSredstva from "./TabelaSredstva";
import ButtonsPocetna from "./ButtonsPocetna";
import { useEffect, useState } from "react";
import { useGlobalContext } from "../../../../../Context/Context";
import DodavanjeSredstva from "./DodavanjeSredstva";
import PreviewSredstvo from "./preview-sredstvo/PreviewSredstvo";
import axios from "axios";

function Pocetna() {
  const [sredstva, setSredstva] = useState([]);
  const [isDodavanje, setIsDodavanje] = useState(false);
  const [editId, setEditId] = useState("");
  const [previewId, setPreviewId] = useState("");

  const { baseUrl, selectedMainEntity } = useGlobalContext();

  const fetchSredstva = () => {
    if (!selectedMainEntity?.company_id) return;
    axios
      .post(`${baseUrl}/spp/read.php`, { company_id: selectedMainEntity.company_id })
      .then(({ data }) => { if (data.status === 200) setSredstva(data.data); })
      .catch(console.error);
  };

  useEffect(() => { fetchSredstva(); }, [selectedMainEntity]);

  const cancelPreview = () => setPreviewId("");

  if (previewId) return <PreviewSredstvo id={previewId} cancelPreview={cancelPreview} />;

  return (
    <div style={{ height: "100%", display: "flex", flexDirection: "column" }}>
      <TabelaSredstva
        sredstva={sredstva}
        setSredstva={setSredstva}
        setEditId={setEditId}
        setPreviewId={setPreviewId}
      />
      {isDodavanje || editId ? (
        <DodavanjeSredstva
          setIsDodavanje={setIsDodavanje}
          setSredstva={setSredstva}
          editId={editId}
          setEditId={setEditId}
          onSaved={fetchSredstva}
        />
      ) : (
        <ButtonsPocetna setIsDodavanje={setIsDodavanje} />
      )}
    </div>
  );
}

export default Pocetna;